import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';


@Component({

  selector: 'rw-duration-selector',  // <home></home>

  styles: [require('./duration-selector.component.css')],

  template: require('./duration-selector.component.html')
})
export class DurationSelectorComponent implements OnInit,OnChanges {


  @Input() public  duration:number = 1;
  @Input() public step:number = 1;
  @Input() public max:number = 20;
  @Input() public min:number = 1;
  @Input() public mode:string = "DAY";

  constructor() {
  }

  public ngOnInit() {
  }

  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;


  }

  onPlus() {
    if (!((this.step + this.duration) > this.max)) {
      this.duration = this.step + this.duration;
    }
  }

  onMinus() {
    if (!((this.duration - this.step) < this.min)) {
      this.duration = this.duration - this.step;
    }
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/duration-selector/duration-selector.component.ts